<template>
  <div data-page-name="newsroom-category">
    <div class="content">
      <ul class="articles">
        <li v-for="article of articles" :key="article.id">
          <ArticlePreview :article />
        </li>
      </ul>
    </div>

    <AppPagination
      v-if="Number(meta.lastPage) > 1"
      v-model="page"
      :total-items="meta.total"
      :items-per-page="meta.perPage"
      :max-pages-shown="4"
    />
  </div>
</template>

<script setup lang="ts">
// components
import AppPagination from '~/components/redesign/AppPagination.vue';
import ArticlePreview from '~/components/redesign/ArticlePreview/ArticlePreview.vue';

// composables
import useApiSeo from '~/composables/useApiSeo';

// utils
import scrollToTop from '~/utils/scrollToTop';
import get from 'lodash.get';

// constants
import { PostType } from '~/types';

const route = useRoute();
const category = computed(() => <string>route.params.category);

const page = ref(1);
watch(page, scrollToTop);

const { error, data } = await useAsyncGql({
  operation: 'BlogArticlesPreviewsFiltered',
  variables: {
    page,
    types: PostType.NEWSROOM,
    category_slugs: [category.value],
  },
  options: {
    transform: data => data.blog_articles,
  },
});

if (error.value || !data.value) {
  showError('Failed to fetch data');
}

const articles = computed(() => get(data.value, 'data', []));
const meta = computed(() => get(data.value, 'paginatorInfo', {}));

useApiSeo(category.value, 'Category');
</script>

<style scoped lang="scss">
@import '$/mixins/typography';
@import '$/mixins/flex';
@import '$/functions/token';
@import '$/variables/fonts';

[data-page-name='newsroom-category'] {
  ul.articles {
    @include flex-stretch-sb;
    flex-direction: column;
    gap: 2rem;

    width: 100%;
  }

  [data-component-name='AppPagination'] {
    margin-top: 5rem;

    @include tablet {
      margin-top: 2rem;
    }

    @include mobile {
      margin-top: 1.5rem;
    }
  }
}
</style>
